<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";

export default {
  data() {
    return {
      locale: zhCN,
    };
  },
  mounted(){
    window.onload = () => {
      this.$cookies.remove('willingbot_store')
    }
    window.onunload = () => {
      // 解决用户信息和权限数据过多导致cookie存储失败的问题
      this.$store.commit('user/getInfo', {})
      this.$store.commit('user/getPermissions', [])
      
      this.$cookies.set('willingbot_store', this.$store.state, "0", '/')
    }
  }
};
</script>
